import { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getAnalytics } from "firebase/analytics";
import { RootState } from "app/store";
import { AnalyticsEventType } from "app/types";
import {
  recordEvent,
  setAnalyticsUserId,
  usesNativeAnalytics,
} from "app/analytics";
import { isProd } from "common/utils";

export const useAnalytics = () => {
  const location = useLocation();
  const parent = useSelector((state: RootState) => state.user.parent);

  useEffect(() => {
    try {
      // ブラウザと Amazon 版のアプリは、Web の Firebase を最初に用意する
      if (!usesNativeAnalytics()) {
        getAnalytics();
      }
    } catch (error) {
      console.warn("Google Analytics Error.");
      console.error(error);
    }
    // recordEvent がその時のパスを付けるので、リスナーは最初に 1 回登録するだけでよい
    const handleVisibilityState = () => {
      recordEvent(
        document.visibilityState === "visible"
          ? AnalyticsEventType.ACTIVE
          : AnalyticsEventType.BACKGROUND,
      );
    };
    document.addEventListener("visibilitychange", handleVisibilityState);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityState);
    };
  }, []);

  useEffect(() => {
    if (parent?.uid) {
      setAnalyticsUserId(parent.uid);
    }
  }, [parent?.uid]);

  // 今までどおり、Web の Firebase で送るとき（ブラウザ・Amazon 版）は最初の表示では送らず、パスが変わったときだけ送る
  const isFirstPageView = useRef(true);
  useEffect(() => {
    const isFirst = isFirstPageView.current;
    isFirstPageView.current = false;
    if (isFirst && !usesNativeAnalytics()) return;
    if (isProd) {
      recordEvent("page_view");
    }
  }, [location]);
};
